const NAME_PATTERN = /^[a-zA-Z0-9_ -]+$/;

export function validateMdaSheetName(name: string): string | undefined {
    if (!name.trim()) {
        return 'Name is required';
    }
    if (!NAME_PATTERN.test(name)) {
        return 'Name must only contain letters, numbers, underscores, spaces, and dashes';
    }
    return undefined;
}
